import { RoutePath, type RoutePaths } from "@/lib/routes"
import { DASHBOARD_ROOT_URL } from "../constants/dashboardRootUrl"

const ecoSessionRoutePath = RoutePath.create(
    `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/eco-session`
)

const ecoSessionAnonymousRoutePath = RoutePath.create(`/anonyme/comptes/:accountNumber/eco-session`)

export const ecoSessionRoutesPaths = {
    ecoSession: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/eco-session?headless=:headless`
    ),
    ecoSessionEnrollment: ecoSessionRoutePath.create("/inscription?headless=:headless"),
    ecoSessionEnrollmentConfirmation: ecoSessionRoutePath.create(
        "/confirmation?headless=:headless"
    ),
    ecoSessionUnenrollmentConfirmation: ecoSessionRoutePath.create(
        "/confirmation-desinscription?headless=:headless"
    ),
    ecoSessionResults: ecoSessionRoutePath.create("/resultats?headless=:headless"),
} as const satisfies RoutePaths

export const ecoSessionAnonymousRoutesPaths = {
    ecoSession: ecoSessionAnonymousRoutePath,
    ecoSessionEnrollment: ecoSessionAnonymousRoutePath.create("/inscription"),
    ecoSessionEnrollmentConfirmation: ecoSessionAnonymousRoutePath.create("/confirmation"),
    ecoSessionUnenrollmentConfirmation: ecoSessionAnonymousRoutePath.create(
        "/confirmation-desinscription"
    ),
    ecoSessionResults: ecoSessionAnonymousRoutePath.create("/resultats"),
} as const satisfies RoutePaths
